<template>
  <div class="app-footer">
    <div class="container">

      <div class="info">
        <div class="copyright">&copy; {{ date }} Collarbone LLC. All rights reserved. Patent pending.</div>

        <i class="icon-logo-horizontal-white"></i>
      </div>

      <ul class="menu">
        <li>
          <router-link to="/legal">Legal</router-link>
        </li>
        <li>
          <router-link to="/api">Partner API</router-link>
        </li>
        <li>
          <router-link to="/api/docs">API Docs</router-link>
        </li>
        <li>
          <router-link to="/press">Press</router-link>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: 'app-footer',
  data() {
    return {
      date: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
  .app-footer {
    background: $blue;
    color: white;

    @include media($mobile) {
      text-align: center;
    }

    a {
      color: white;
    }
  }

  .info {
    margin-bottom: 15px;

    @include media($notMobile) {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .copyright {
    @include media($mobile) {
      margin-bottom: 15px;
    }
  }

  .menu {
    font-weight: bold;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      @include media($notMobile) {
        display: inline-block;
        margin-right: 25px;
      }

      @include media($mobile) {
        margin-bottom: 15px;
      }
    }
  }
</style>
